import { render, staticRenderFns } from "./DocumentOutlineIcon.vue?vue&type=template&id=f21a5d54&scoped=true"
import script from "./DocumentOutlineIcon.vue?vue&type=script&lang=ts"
export * from "./DocumentOutlineIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21a5d54",
  null
  
)

export default component.exports